import { ChartType } from '../features/dashboard/model';

const CHART_TYPE_QUERY_PARAM_KEY = 'chart';

export function readChartTypeFromUrl(defaultIfNone = ChartType.bar): ChartType {
  const url = new URL(window.location.href);
  const rawChatTypeURLParams = url.searchParams.get(CHART_TYPE_QUERY_PARAM_KEY);

  if (rawChatTypeURLParams == null) {
    return defaultIfNone;
  }

  const chartType = ChartType[rawChatTypeURLParams as keyof typeof ChartType];
  return chartType ?? defaultIfNone;
}
